export default {
  // Options.jsx
  items_per_page: '/ පිටුව',
  jump_to: 'වෙත යන්න',
  jump_to_confirm: 'තහවුරු',
  page: 'පිටුව',
  // Pagination.jsx
  prev_page: 'කලින් පිටුව',
  next_page: 'ඊළඟ පිටුව',
  prev_5: 'කලින් පිටු 5',
  next_5: 'ඊළඟ පිටු 5',
  prev_3: 'කලින් පිටු 3',
  next_3: 'ඊළඟ පිටු 3',
  page_size: 'පිටුවේ ප්‍රමාණය'
};